import type { WidgetDataContract } from "@nexus/widget-sdk";

/**
 * `protection-overview-tenant-eis` v1 — one tenant's monthly Event Integrity
 * Score trend for one published Protection Overview report edition.
 *
 * A tenant with no report data for this edition (e.g. out of scope for the
 * period) still gets a row, with an empty `eisMonthly` — the widget shows an
 * explicit empty state rather than treating it as an error.
 */
export const PROTECTION_OVERVIEW_EIS_CONTRACT: WidgetDataContract = {
  name: "protection-overview-tenant-eis",
  version: 1,
};

export interface ProtectionOverviewEisTenant {
  id: number;
  label: string;
  region: string;
}

export interface ProtectionOverviewEisFreshness {
  generatedAt: string;
  dataThrough: string;
  /** "demo", "clickhouse", or a named upstream feed. */
  source: string;
  isEstimated: boolean;
}

export interface ProtectionOverviewEisData {
  tenant: ProtectionOverviewEisTenant;
  /** Monthly average EIS (0-100), oldest to newest. Empty when there is no data. */
  eisMonthly: number[];
  freshness: ProtectionOverviewEisFreshness;
}
